import { Icon } from "@iconify/react/dist/iconify.js";
import { motion } from "framer-motion";

/**
 * Vista "Por Fortaleza" (agrupada por frase).
 * Dentro de cada tarjeta se listan las respuestas junto con el talento
 * al que pertenecen, al estilo de TabPorPregunta del summary de confirmación.
 */
const PtTabPorFortaleza = ({ preguntas }) => {
  if (!preguntas || preguntas.length === 0) {
    return (
      <div className="cs-empty-state">
        <Icon icon="mdi:information-outline" />
        <span>No hay respuestas registradas.</span>
      </div>
    );
  }

  return (
    <div className="row">
      {preguntas.map((grupo, cardIndex) => {
        const items = (grupo.talentos || []).flatMap((t) =>
          (t.respuestas || []).map((r) => ({
            ...r,
            talento: t.talento,
            talento_id: t.talento_id,
          }))
        );
        const total = items.length;
        const totalSi = items.filter((r) => r.valor).length;

        return (
          <motion.div
            key={grupo.frase_id}
            className="col-lg-6 col-12 mb-20"
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              delay: 0.1 + cardIndex * 0.08,
              duration: 0.4,
              ease: "easeOut",
            }}
          >
            <div className="card radius-12 h-100 cs-talent-card">
              <div className="card-body p-20">
                <div className="cs-talent-header">
                  <div
                    className="d-flex align-items-start gap-2"
                    style={{ flex: 1, minWidth: 0 }}
                  >
                    <div className="cs-question-icon-wrap">
                      <Icon icon="mdi:target" />
                    </div>
                    <h4
                      className="cs-pregunta-title mb-0"
                      style={{
                        fontSize: "clamp(0.78rem, 1.9vw, 0.88rem)",
                      }}
                    >
                      Fortaleza {grupo.tipo_fortaleza} · {grupo.frase}
                    </h4>
                  </div>
                  <span
                    className="cs-talent-badge"
                    style={{ flexShrink: 0 }}
                  >
                    {totalSi}/{total} Sí
                  </span>
                </div>

                {total > 0 ? (
                  <div className="cs-frases-list cs-frases-scroll">
                    {items.map((r, i) => (
                      <motion.div
                        key={`${r.sub_frase_id}-${r.talento_id}`}
                        className={`pt-summary-row-agrupada ${
                          r.valor ? "si" : "no"
                        }`}
                        initial={{ opacity: 0, x: -10 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{
                          delay: 0.1 + cardIndex * 0.08 + i * 0.04,
                          duration: 0.26,
                        }}
                      >
                        <Icon
                          icon={
                            r.valor
                              ? "mdi:check-circle"
                              : "mdi:close-circle"
                          }
                          className="pt-summary-row-check-icon"
                        />
                        <span className="pt-summary-row-text">{r.texto}</span>
                        <span className="cs-talento-chip">{r.talento}</span>
                      </motion.div>
                    ))}
                  </div>
                ) : (
                  <div className="cs-empty-state">
                    <Icon icon="mdi:minus-circle-outline" />
                    <span>Sin respuestas</span>
                  </div>
                )}
              </div>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
};

export default PtTabPorFortaleza;
